import { camelCaseTransformer } from '@sondermind/utilities/tools';

export interface IClientTestimonialResponse {
  client_state: string;
  date_feedback_collected: string;
  feedback: string;
}

export interface IClientTestimonial {
  clientState: string;
  dateFeedbackCollected: string;
  feedback: string;
}

export function clientTestimonialResponseTransformer(
  apiResponse: IClientTestimonialResponse[]
): IClientTestimonial[] {
  return camelCaseTransformer<IClientTestimonial[]>(apiResponse);
}
